export const PathRoot = {
    root: "/",
    auth: "auth/*",
    inmersys: "inmersys/*",
    cms: "cms/*",
    project: "project/*",
    graph: "graph/*",
    anality: "analisis/*",
    notfound: "*",
};

export const AuthRoot = {
    root: "/auth",
    reset: "reset",
};

export const InmersysRoot = {
    root: "/inmersys",
    graph: "graph",
    user: "user",
    newProject: "newproject",
    cms: "cms",
    project: "project",
    projectinmersys: "projectinmersys",
    buscador: "buscador",
    anality: "analisis",
};

export const graphRoot = {
    root: "/inmersys/graph",
    internal: "internal",
    area: "area",
    semaforo: "semaforo",
};

export const CmsRoot = {
    root: "/inmersys/cms",
    area: "area",
    hoursdevelop: "hoursdevelop",
    plaforms: "plaforms",
    categories: "categories",
    pauses: "pauses",
    tags: "tags",
    statusProject: "statusProject",
};

export const ProjectRoot = {
    selectproject: ":id",
    proyeccion: "proyeccion",
    simulation: "simulation",
    backlog: "backlog",
};

export const AnalityRoot = {
    root: "/inmersys/analisis",
    sizeProyect: "tamano",
    download: "download",
    redProjects: "overtime",
    tableWeeks: "tableWeeks",
    lp: "lp"
};
